// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fd-a";
export var fulfillmentFormRail = "_fd-9";
export var headerTitleRow = "_fd-c";
export var orderDetailsWrapper = "_fd-7";
export var paymentInformationGrid = "_fd-h";
export var paymentSummaryColumn = "_fd-i";
export var shipmentContainer = "_fd-b";
export var shipmentDetailsMainPane = "_fd-8";
export var shipmentNavigationCard = "_fd-5";
export var shipmentNavigationRail = "_fd-3";
export var shipmentNavigationRailHeader = "_fd-4";
export var shipmentSummaryFact = "_fd-e";
export var shipmentSummaryGrid = "_fd-d";
export var shipmentSummaryMetadataRow = "_fd-f";
export var shipmentSummaryTags = "_fd-g";
export var shipmentWorkspace = "_fd-0";
export var shipmentWorkspaceBody = "_fd-2";
export var shipmentWorkspaceContent = "_fd-6";
export var shipmentWorkspaceHeader = "_fd-1";